import { FormGroup, FormBuilder, Validators, } from "@angular/forms";
import { ExperimentDesignFormValidatorsService } from "../../experiment-design-form/experiment-design-form-validators.service";
var SprayBoothStudyFormComponent = /** @class */ (function () {
    function SprayBoothStudyFormComponent(fb, validators) {
        this.fb = fb;
        this.validators = validators;
        this.selectedTab = 0;
        this.activeIngredient = "";
        this.concentrationValue = "";
        this.concentrationUnit = "";
    }
    SprayBoothStudyFormComponent.prototype.ngOnInit = function () { };
    SprayBoothStudyFormComponent.prototype.hasSprayStudyError = function (sprayStudy) {
        return sprayStudy.invalid && (sprayStudy.dirty || sprayStudy.touched);
    };
    Object.defineProperty(SprayBoothStudyFormComponent.prototype, "sprayBoothStudy", {
        get: function () {
            return this.treatment.get("sprayBoothStudy");
        },
        enumerable: true,
        configurable: true
    });
    SprayBoothStudyFormComponent.prototype.getActive = function (index) {
        return this.sprayBoothStudy.at(index).get("actives");
    };
    SprayBoothStudyFormComponent.prototype.getAdjuvant = function (index) {
        return this.sprayBoothStudy.at(index).get("adjuvants");
    };
    SprayBoothStudyFormComponent.prototype.applicationTimepointId = function (index) {
        return (this.sprayBoothStudy.at(index).get("applicationTimepointId"));
    };
    SprayBoothStudyFormComponent.prototype.applicationVolumeId = function (index) {
        return (this.sprayBoothStudy.at(index).get("applicationVolumeId"));
    };
    // Active Form Controls
    SprayBoothStudyFormComponent.prototype.activeId = function (index, activeIndex) {
        var activeArray = this.getActive(index);
        if (activeArray.length > 0) {
            return activeArray.at(activeIndex).get("activeId");
        }
        return this.fb.control(null);
    };
    SprayBoothStudyFormComponent.prototype.getActiveIngredient = function (index, activeIndex) {
        return (this.getActive(index).at(activeIndex).get("activeIngredient"));
    };
    SprayBoothStudyFormComponent.prototype.getConcentrationValue = function (index, activeIndex) {
        return (this.getActive(index).at(activeIndex).get("concentrationValue"));
    };
    SprayBoothStudyFormComponent.prototype.getConcentrationUnit = function (index, activeIndex) {
        return (this.getActive(index).at(activeIndex).get("concentrationUnit"));
    };
    SprayBoothStudyFormComponent.prototype.getRateValue = function (index, activeIndex) {
        return this.getActive(index).at(activeIndex).get("rateValue");
    };
    SprayBoothStudyFormComponent.prototype.getRateUnitId = function (index, activeIndex) {
        return this.getActive(index).at(activeIndex).get("rateUnitId");
    };
    SprayBoothStudyFormComponent.prototype.getRelativeFieldRate = function (index, activeIndex) {
        return (this.getActive(index).at(activeIndex).get("relativeFieldRate"));
    };
    // Adjuvant Form Controls
    SprayBoothStudyFormComponent.prototype.getAdjuvantId = function (index, adjuvantIndex) {
        return (this.getAdjuvant(index).at(adjuvantIndex).get("adjuvantId"));
    };
    SprayBoothStudyFormComponent.prototype.getAdjuvantValue = function (index, adjuvantIndex) {
        return (this.getAdjuvant(index).at(adjuvantIndex).get("adjuvantValue"));
    };
    SprayBoothStudyFormComponent.prototype.addActive = function (index) {
        var activeGroup = this.fb.group({
            activeId: [null, [Validators.required]],
            rateValue: [
                "",
                [Validators.required, Validators.pattern(/^(\d{0,10}\.\d{1,10}|\d{1,10})$/)],
            ],
            rateUnitId: [null, [Validators.required]],
            relativeFieldRate: [
                "",
                [Validators.required, Validators.pattern(/^(\d{0,10}\.\d{1,10}|\d{1,10})$/)],
            ],
        });
        this.getActive(index).push(activeGroup);
        var group = this.sprayBoothStudy.at(index);
        group.markAsDirty();
        group.updateValueAndValidity();
    };
    SprayBoothStudyFormComponent.prototype.removeActive = function (index, activeIndex) {
        this.getActive(index).removeAt(activeIndex);
    };
    SprayBoothStudyFormComponent.prototype.addAdjuvant = function (index) {
        var adjuvantGroup = this.fb.group({
            adjuvantId: [null, [Validators.required]],
            adjuvantValue: [
                "",
                [Validators.required, Validators.pattern(/^(\d{0,10}\.\d{1,10}|\d{1,10})$/)],
            ],
        });
        this.getAdjuvant(index).push(adjuvantGroup);
        var group = this.sprayBoothStudy.at(index);
        group.markAsDirty();
        group.updateValueAndValidity();
    };
    SprayBoothStudyFormComponent.prototype.removeAdjuvant = function (index, adjuvantIndex) {
        this.getAdjuvant(index).removeAt(adjuvantIndex);
    };
    SprayBoothStudyFormComponent.prototype.addSprayEvent = function () {
        var sprayEventGroup = this.fb.group({
            applicationVolumeId: [null, Validators.required],
            applicationTimepointId: [null, Validators.required],
            actives: this.fb.array([]),
            adjuvants: this.fb.array([]),
        });
        sprayEventGroup.setValidators(this.validators.atLeastOneActiveOrAdjuvantValidator());
        this.sprayBoothStudy.push(sprayEventGroup);
        sprayEventGroup.updateValueAndValidity();
    };
    SprayBoothStudyFormComponent.prototype.getDisplayIngredient = function (treatmentIndex, activeIndex) {
        var activeIdControl = this.getActive(treatmentIndex)
            .at(activeIndex)
            .get("activeId");
        if (!activeIdControl) {
            return "";
        }
        var activeId = +activeIdControl.value;
        var selected = this.activeOptions.find(function (x) {
            return x.id === activeId;
        });
        return selected ? selected.activeIngredient : "";
    };
    SprayBoothStudyFormComponent.prototype.getDisplayConcentrationValue = function (treatmentIndex, activeIndex) {
        var activeId = +this.getActive(treatmentIndex)
            .at(activeIndex)
            .get("activeId").value;
        var selected = this.activeOptions.find(function (x) {
            return x.id === activeId;
        });
        return selected ? selected.concentrationValue : "";
    };
    SprayBoothStudyFormComponent.prototype.getDisplayConcentrationUnit = function (treatmentIndex, activeIndex) {
        var activeId = +this.getActive(treatmentIndex)
            .at(activeIndex)
            .get("activeId").value;
        var selected = this.activeOptions.find(function (x) {
            return x.id === activeId;
        });
        return selected ? selected.concentrationUnit : "";
    };
    SprayBoothStudyFormComponent.prototype.getDisplayAdjuvantUnit = function (treatmentIndex, adjuvantIndex) {
        var adjuvantId = +this.getAdjuvant(treatmentIndex)
            .at(adjuvantIndex)
            .get("adjuvantId").value;
        var selectedAdjuvant = this.adjuvantOptions.find(function (x) { return x.id === adjuvantId; });
        if (!selectedAdjuvant) {
            return "";
        }
        var unit = this.sprayStudyOptions.adjuvantUnits.find(function (u) { return u.id === selectedAdjuvant.adjuvantUnitId; });
        return unit ? unit.display : "";
    };
    SprayBoothStudyFormComponent.prototype.onTradeNameChange = function (selectedId, treatmentIndex, sprayIndex, activeIndex) {
        var id = Number(selectedId);
        var selected = this.activeOptions.find(function (opt) {
            return opt.id === id;
        });
        if (!selected) {
            return;
        }
        var formGroup = this.getActive(treatmentIndex).at(sprayIndex);
        formGroup.controls["activeIngredient"].setValue(selected.activeIngredient);
        formGroup.controls["concentrationValue"].setValue(selected.concentrationValue);
        formGroup.controls["concentrationUnit"].setValue(selected.concentrationUnit);
    };
    SprayBoothStudyFormComponent.prototype.deleteSprayEvent = function (index) {
        this.sprayBoothStudy.removeAt(index);
    };
    SprayBoothStudyFormComponent.prototype.copyAllSprayEvents = function (copyArgs) {
        var formArray = this.sprayBoothStudy;
        while (formArray.length > 0) {
            formArray.removeAt(0);
        }
        for (var i = 0; i < copyArgs.sprayEvents.length; i++) {
            var event_1 = copyArgs.sprayEvents[i];
            var newGroup = this.fb.group({
                applicationVolumeId: [event_1.applicationVolumeId, Validators.required],
                applicationTimepointId: [
                    event_1.applicationTimepointId,
                    Validators.required,
                ],
                actives: this.fb.array([]),
                adjuvants: this.fb.array([]),
            });
            var activesArray = newGroup.get("actives");
            for (var j = 0; j < event_1.actives.length; j++) {
                var active = event_1.actives[j];
                activesArray.push(this.fb.group({
                    activeId: [active.activeId, Validators.required],
                    rateValue: [
                        active.rateValue,
                        [Validators.required, Validators.pattern(/^(\d{0,10}\.\d{1,10}|\d{1,10})$/)],
                    ],
                    rateUnitId: [active.rateUnitId, Validators.required],
                    relativeFieldRate: [
                        active.relativeFieldRate,
                        [Validators.required, Validators.pattern(/^(\d{0,10}\.\d{1,10}|\d{1,10})$/)]
                    ],
                }));
            }
            var adjuvantsArray = newGroup.get("adjuvants");
            for (var k = 0; k < event_1.adjuvants.length; k++) {
                var adjuvant = event_1.adjuvants[k];
                adjuvantsArray.push(this.fb.group({
                    adjuvantId: [adjuvant.adjuvantId, Validators.required],
                    adjuvantValue: [
                        adjuvant.adjuvantValue,
                        [Validators.required, Validators.pattern(/^(\d{0,10}\.\d{1,10}|\d{1,10})$/)],
                    ]
                }));
            }
            formArray.push(newGroup);
        }
    };
    SprayBoothStudyFormComponent.prototype.clearFormArray = function (formArray) {
        while (formArray.length !== 0) {
            formArray.removeAt(0);
        }
    };
    return SprayBoothStudyFormComponent;
}());
export { SprayBoothStudyFormComponent };



// WEBPACK FOOTER //
// F:/PHAZP5152IS01-4/_work/202/s/src/app/request-creation/experiment-design/spray-booth-study/spray-booth-study-form/spray-booth-study-form.component.ts.pre-build-optimizer.js